export default __webpack_public_path__ + "static/media/map-2.ad74fe59.svg";